import { render, staticRenderFns } from "./transfer-campus.vue?vue&type=template&id=3384c980&"
import script from "./transfer-campus.vue?vue&type=script&lang=js&"
export * from "./transfer-campus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports